<template>
  <teleport v-if="widget && !isabo" :to="'#' + teleport">
    <div class="orm-offersslider" v-if="offers">
      <div class="orm-container orm-pt-56 orm-pb-70" v-if="offers.length > 0">
        <div class="orm-row center-xs">
          <div class="orm-col-xs-12 orm-col-sm-11 orm-px-0 orm-relative">
            <Slider
              v-if="offers.length > 0 && type == 1"
              :images="offers"
              :autoplay="false"
              :intervall="10000"
              ratio="16/9"
              :arrows="false"
              :controll-next="true"
              :controlls-fade="false"
              :sttype="sttype"
            />
            <Slider
              v-if="offers.length > 0 && type == 2"
              :images="offers"
              :autoplay="false"
              :intervall="10000"
              ratio="16/9"
              :arrows="true"
              :controlls-fade="true"
              :sttype="sttype"
            />
          </div>
        </div>
      </div>

      <!-- <div
        class="orm-col-xs-12 text-center orm-my-16"
        v-if="offers && type == 1 && demo == 'true'"
      >
        <h2 class="orm-headline__h4">
          Angebotsmodul: Auto-Loop, Steuerung über Punkte
        </h2>
      </div>

      <div
        class="orm-col-xs-12 text-center orm-my-16"
        v-if="offers && type == 2 && demo == 'true'"
      >
        <h2 class="orm-headline__h4">
          Angebotsmodul: kein Auto-Loop, Steuerung über Pfeile und Punkte,
          Einblendung auf Mouseover
        </h2>
      </div> -->
    </div>
  </teleport>
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store";
import Slider from "@/components/ui/slider/offers-slider.vue";

export default defineComponent({
  name: "OffersSlider",
  components: { Slider },
  data() {
    return {
      offers: null,
      demo: process.env.VUE_APP_DEMO,
      isabo: false,
    };
  },
  props: {
    type: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  async created() {
    if (
      store.getters["ORMgeneral/GET_MODULE"]("ORM_ANGEBOTE") == "J" &&
      process.env.VUE_APP_OFFERS == "true"
    ) {
      await store.dispatch("offers/SET_OFFERS");
      const stationID = await store.getters["userSession/GET_STATION"];
      // console.log(stationID);
      const branch = await store.getters["stations/GET_STATION_BY_ID"](
        stationID
      )?.branch;
      // console.log(station);
      if (branch === "Auto-Abo") this.isabo = true;

      store.watch(
        // eslint-disable-next-line
        (state, getters) => getters["userSession/GET_STATION"],
        (val) => {
          const branch = store.getters["stations/GET_STATION_BY_ID"](val)
            .branch;
          if (branch === "Auto-Abo") {
            this.isabo = true;
          } else {
            this.isabo = false;
          }
        }
      );

      const element = document.querySelector("#crentOffersSlider");
      let selectedItems = null;
      if (element) {
        if (element.getAttribute("data-selecteditems")) {
          selectedItems = element.getAttribute("data-selecteditems");
        }
      }
      const allOffers = store.getters["offers/GET_OFFERS"];

      if (selectedItems != null && selectedItems != 0) {
        let selectedItemsArr = selectedItems.split(",").map(Number);
        selectedItemsArr = selectedItemsArr.map((num) => num - 1);

        selectedItemsArr = selectedItemsArr.map((num) => {
          if (num < 0) {
            return 0;
          }
          if (num > allOffers.length) {
            return null;
          }
          return num;
        });
        this.offers = allOffers.filter((_, index) =>
          selectedItemsArr.includes(index)
        );
      } else {
        this.offers = allOffers;
      }
    }
  },
  setup(props) {
    let teleport = "crentOffersSlider";
    if (props.type == 2) {
      teleport = "crentOffersSlider2";
    }
    let widget = false;
    const myEle = document.getElementById(teleport);

    if (myEle !== null) {
      widget = true;
    }

    return {
      widget,
      teleport,
      // offers,
    };
  },
});
</script>
